// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import SelectUserModal from '../../modals/select_user_modal'

up.compiler('.new-competence', (element) => {
  up.on(element, 'click', function(e) {
    e.preventDefault()
    e.stopPropagation()

    new SelectUserModal().open().then((user) => {
      if (!user) { return }

      up.visit(element.getAttribute('competence-form-url'), {
        params: { user_id: user.id },
        target: '.modal',
        history: false,
      })
    })
  })
})
